import { useEffect } from 'react'
import { useDispatch } from 'react-redux';
import { action_setFirstLoad, action_setPolinomyStructurePolinomy } from '../../../reducers/actions/Adjustment/actions';
import { getAdjustmentStructurePolinomy } from '../../../services/sAdjustment/structure.service';

const useGetAdjustmentPolynomyStructure = (structure, l_indicadores_id, l_element_id, wHeader) => {    
    const dispatch = useDispatch();

    useEffect(()=> {
        const doIt = async () => {
            try {
                let serviceResponse = await getAdjustmentStructurePolinomy(l_element_id, l_indicadores_id, wHeader);

                if (serviceResponse.data.succeeded) {
                    const response = serviceResponse.data.data;

                    dispatch(action_setPolinomyStructurePolinomy(response))
                }
                else {
                    dispatch(action_setPolinomyStructurePolinomy([]))
                }
            }
            catch (error) {
                dispatch(action_setPolinomyStructurePolinomy([]))
            }

            dispatch(action_setFirstLoad(true))
        }
        
        if (structure === null && l_element_id !== null && l_indicadores_id !== null) {
            doIt()
        }
    }, [structure, l_indicadores_id, l_indicadores_id, wHeader]);
}

export { useGetAdjustmentPolynomyStructure }